import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../theme/ThemeContext';

interface ModernThemeToggleProps {
  className?: string;
}

export function ModernThemeToggle({ className = '' }: ModernThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className={`flex bg-gray-100 dark:bg-gray-700 rounded-lg p-1 w-fit ${className}`}>
      <button
        onClick={() => theme === 'dark' && toggleTheme()}
        className={`
          flex items-center justify-center w-8 h-8 rounded-md transition-all duration-200
          ${
            theme === 'light'
              ? 'bg-white dark:bg-gray-600 shadow-sm'
              : 'hover:bg-gray-200 dark:hover:bg-gray-600'
          }
        `}
        data-ph-capture-attribute="btn-light-mode"
      >
        <Sun
          className={`h-4 w-4 ${theme === 'light' ? 'text-gray-700' : 'text-gray-500 dark:text-gray-400'}`}
        />
      </button>
      <button
        onClick={() => theme === 'light' && toggleTheme()}
        className={`
          flex items-center justify-center w-8 h-8 rounded-md transition-all duration-200
          ${
            theme === 'dark'
              ? 'bg-white dark:bg-gray-600 shadow-sm'
              : 'hover:bg-gray-200 dark:hover:bg-gray-600'
          }
        `}
        data-ph-capture-attribute="btn-dark-mode"
      >
        <Moon
          className={`h-4 w-4 ${theme === 'dark' ? 'text-gray-700' : 'text-gray-500 dark:text-gray-400'}`}
        />
      </button>
    </div>
  );
}
